import { z } from 'zod'

import { FlexibleAgentStepType } from 'shared/api/requests/aiAgent/schemas'
import { SocketEventBaseSchema } from 'utils/services/notificationsService/constants'

const customGoalDraftSchema = z.object({
  type: z.literal(FlexibleAgentStepType.CUSTOM),
  config: z.object({
    goal: z.string(),
  }),
})

const collectInfoDraftSchema = z.object({
  type: z.literal(FlexibleAgentStepType.COLLECT_INFO),
  config: z.object({
    question: z.string(),
  }),
})

const aiGeneratedAgentDraftSchema = z.object({
  goal: z.string(),
  context: z.string(),
  scenario: z.array(z.discriminatedUnion('type', [customGoalDraftSchema, collectInfoDraftSchema])),
})

export type AiGeneratedAgentDraft = z.infer<typeof aiGeneratedAgentDraftSchema>

export const AiAgentGeneratorSocketEventsSchemas = {
  agentGenerated: SocketEventBaseSchema.extend({
    event: z.literal('ai_agent_generated'),
    model: aiGeneratedAgentDraftSchema,
    session_id: z.string(),
  }),

  generationFailed: SocketEventBaseSchema.extend({
    event: z.literal('ai_agent_generation_failed'),
    session_id: z.string(),
  }),
}
